import { useEffect, useState } from "react";
import { api, authedFileUrl } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Loader2, FileText, Eye } from "lucide-react";

export default function ParentDocuments() {
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [preview, setPreview] = useState(null);

    useEffect(() => {
        api.get("/documents").then((r) => setDocs(r.data.documents)).finally(() => setLoading(false));
    }, []);

    if (loading) return <div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-primary" /></div>;

    return (
        <div className="space-y-6" data-testid="parent-documents-page">
            <div>
                <div className="text-xs uppercase tracking-wider text-muted-foreground">Files</div>
                <h1 className="font-heading text-3xl font-black tracking-tight mt-1">Documents</h1>
                <p className="text-muted-foreground mt-1">Preview important PDF documents shared by the school.</p>
            </div>

            {docs.length === 0 ? (
                <div className="text-center py-16 border border-dashed border-border rounded-3xl">
                    <FileText className="h-10 w-10 mx-auto text-muted-foreground mb-2" />
                    <p className="text-sm text-muted-foreground">No documents available yet.</p>
                </div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {docs.map((d) => (
                        <Card key={d.id} className="rounded-2xl">
                            <CardHeader>
                                <div className="flex items-start gap-3">
                                    <div className="h-12 w-12 rounded-2xl bg-secondary flex items-center justify-center shrink-0">
                                        <FileText className="h-6 w-6 text-secondary-foreground" />
                                    </div>
                                    <div className="min-w-0 flex-1">
                                        <CardTitle className="font-heading text-lg truncate">{d.title}</CardTitle>
                                        <CardDescription>Uploaded {new Date(d.uploaded_at).toLocaleDateString()}</CardDescription>
                                    </div>
                                </div>
                            </CardHeader>
                            <CardContent>
                                <Button onClick={() => setPreview(d)} className="w-full rounded-full" data-testid={`preview-doc-${d.id}`}>
                                    <Eye className="h-4 w-4 mr-2" /> Preview
                                </Button>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            )}

            <Dialog open={!!preview} onOpenChange={(o) => !o && setPreview(null)}>
                <DialogContent className="max-w-5xl h-[85vh] p-0 rounded-2xl overflow-hidden flex flex-col">
                    <DialogHeader className="p-4 border-b border-border">
                        <DialogTitle className="font-heading">{preview?.title}</DialogTitle>
                    </DialogHeader>
                    <div className="flex-1 bg-muted">
                        {preview && (
                            <iframe
                                title={preview.title}
                                src={`${authedFileUrl(preview.pdf_url)}#toolbar=0&navpanes=0&scrollbar=0`}
                                className="w-full h-full"
                                style={{ pointerEvents: "auto" }}
                                data-testid="pdf-preview-iframe"
                            />
                        )}
                    </div>
                    <div className="p-3 text-xs text-center text-muted-foreground bg-card border-t border-border">
                        Preview only. Downloads are not permitted for parents.
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    );
}
